import { createDetailDialog } from 'dialogs/common'
import { dialogSizes } from 'dialogs'
import Form from 'pages/wines/form'
import { api, actionCreators } from 'store/modules/wines'

const metadata = {
  icon: 'glass',
  page: 'wines',
  dialogSize: dialogSizes.XL
}

export default createDetailDialog({ metadata, api, actionCreators, Form })
